module.exports = __webpack_public_path__ + "static/media/17.b0fb9b19.jpeg";